import React from 'react';
import SectionHeader from './SectionHeader';
import { Reveal } from './ScrollReveal';

export default function Structure() {
  const formats = [
    {
      num: "01",
      tag: "Format 1",
      title: "Peer-to-Peer<br/>Board Meeting",
      freq: "1 Tag pro Monat · Wiederkehrend · Geschlossene Gruppe",
      modeDot: "bg-brand-gold",
      modeText: "Gruppe · je Zielgruppe · branchengemischt",
      modeColor: "text-brand-gold",
      features: [
        "3 Kreise — je einer für GF, Gründer & Solopreneure",
        "Max. 4 Mitglieder pro Kreis — jeden Monat dieselben Menschen",
        "Gleiche Herausforderungen, nie dieselbe Branche",
        "Strategie, Wachstum & langfristige Entscheidungen",
        "Strukturiert wie ein echtes Board — mit Aktionspunkten",
        "Harald moderiert & hält den Rahmen"
      ],
      rule: "<strong>Die Kernregel:</strong> Nie zwei Personen aus derselben Branche — in keinem der drei Kreise. Weil echte Offenheit nur ohne Interessenkonflikt möglich ist."
    },
    {
      num: "02",
      tag: "Format 2",
      title: "Persönliches<br/>Sparring 1:1",
      freq: "1 Stunde pro Woche · Fixer Termin",
      modeDot: "bg-[#5cb88a]",
      modeText: "Ausschließlich 1:1 · nur du und Harald",
      modeColor: "text-[#5cb88a]",
      features: [
        "Für alles, was nicht in den Kreis gehört",
        "Aktuelle Entscheidungen & was gerade drückt",
        "Führungsthemen & persönliche Entwicklung",
        "Fixer Wochentermin — nicht „bei Bedarf\"",
        "Vertraulich — kein Dritter hört zu"
      ],
      rule: "<strong>Der Unterschied:</strong> Das Board Meeting gibt Perspektiven von außen. Das 1:1 gibt den vertraulichen Raum dazwischen — für alles, was zu persönlich für die Gruppe ist."
    }
  ];

  return (
    <section id="struktur" className="py-32 relative z-10">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="02" 
          eyebrow="Die Sparring Struktur" 
          title="Zwei Formate.<br/><em class='not-italic italic text-brand-gold'>Eine Partnerschaft.</em>" 
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[2px] bg-brand-border border-2 border-brand-border shadow-2xl">
          {formats.map((format, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <div className="group bg-brand-dark p-14 relative overflow-hidden transition-all duration-500 hover:bg-brand-surface h-full">
                <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-brand-gold to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100"></div>
                <div className="font-serif text-[6rem] font-light text-brand-border2/20 leading-none absolute top-8 right-10 tracking-[-0.03em] select-none">{format.num}</div>
                <div className="inline-block text-[0.7rem] font-bold tracking-[0.2em] uppercase text-brand-gold border border-brand-gold/30 px-5 py-2 rounded-sm mb-10">
                  {format.tag}
                </div>
                <h3 className="font-serif text-[clamp(1.8rem,3vw,2.5rem)] font-normal text-brand-white leading-tight mb-4" dangerouslySetInnerHTML={{ __html: format.title }} />
                <div className="text-[0.9rem] font-semibold text-brand-muted mb-12">{format.freq}</div>
                <div className="flex items-center gap-3 text-[0.8rem] font-bold tracking-[0.12em] uppercase mb-10">
                  <span className={`w-2 h-2 rounded-full animate-pulse-slow ${format.modeDot}`}></span>
                  <span className={format.modeColor}>{format.modeText}</span>
                </div>
                <ul className="list-none space-y-2 mb-12">
                  {format.features.map((feature, i) => (
                    <li key={i} className="text-[1.05rem] text-brand-text py-3 border-b border-brand-border/40 flex items-start gap-5 leading-relaxed last:border-b-0 group-hover:text-brand-white transition-colors">
                      <span className="text-brand-gold font-bold shrink-0 mt-[2px]">—</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <div className="mt-auto p-7 bg-brand-gold/5 border-l-4 border-brand-gold">
                  <p className="text-[0.95rem] text-brand-text leading-relaxed" dangerouslySetInnerHTML={{ __html: format.rule }} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}